import { Input, InputDiv } from './style'

const InputComponent = ({
  name,
  onChange,
  placeholder,
  value,
  label,
  disabled,
  height,
  width,
  margin,
  defaultValue,
  view,
  login,
  className,
  type,
  id,
}) => {
  return (
    <InputDiv login={login} className={className}>
      <label>{label}</label>
      <Input
        id={id}
        login={login}
        type={type}
        defaultValue={defaultValue}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        value={value}
        disabled={disabled || view}
        height={height}
        width={width}
        margin={margin}
        view={view}
      />
    </InputDiv>
  )
}
export default InputComponent
